export default "__VITE_ASSET__t$0mrSfC__"